<template>
  <div>
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
          <div class="grid grid-cols-12 gap-x-2">
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Field</label>
                <select v-model="filter.field" class="form-select">
                  <option value="estimation_no">Estimation No.</option>
                  <option value="estimation_date">Date</option>
                  <option value="manager_name">Manager/User</option>
                  <option value="status">Status</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-3 xl:col-span-2 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Type</label>
                <select v-model="filter.type" class="form-select">
                  <option value="like">like</option>
                  <option value="=">=</option>
                  <option value="!=">!=</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Value</label>
                <input v-model="filter.value" type="text" class="form-control sm:w-40" placeholder="Search..." />
              </div>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button type="button" class="btn btn-primary w-full" @click="onFilter">Go</button>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button type="button" class="btn btn-secondary w-full" @click="onResetFilter">Reset</button>
            </div>
          </div>
        </form>
        <div class="flex mt-5 sm:mt-0">
          <router-link :to="{ name: 'estimation-create' }" class="btn btn-primary shadow-md mr-2">
            Add Estimation
          </router-link>
          <div class="dropdown w-1/2 sm:w-auto">
            <button class="dropdown-toggle btn btn-outline-secondary w-full sm:w-auto" aria-expanded="false">
              <FileTextIcon class="w-4 h-4 mr-2" /> Export
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button>
            <div class="dropdown-menu w-40">
              <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
                <a href="javascript:;" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md" @click="onExportCsv">
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export CSV
                </a>
                <a href="javascript:;" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md" @click="onExportXlsx">
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export XLSX
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div ref="tableRef" class="mt-5 table-report table-report--tabulator"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { defineComponent, inject, onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import xlsx from 'xlsx'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import { BASE_URL, v_per_page_record, v_per_page_size } from '@/constants/config.js'

export default defineComponent({
  setup() {
    const router = useRouter()
    const swal = inject('$swal')
    const tableRef = ref()
    const tabulator = ref()
    const filter = reactive({
      field: 'estimation_no',
      type: 'like',
      value: ''
    })

    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: BASE_URL + 'api/estimation/list',
        ajaxConfig: {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=utf-8',
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        },
        ajaxFiltering: true,
        ajaxSorting: true,
        printAsHtml: true,
        printStyled: true,
        pagination: 'remote',
        paginationSize: v_per_page_record,
        paginationSizeSelector: v_per_page_size,
        layout: 'fitColumns',
        responsiveLayout: 'collapse',
        placeholder: 'No matching records found',
        columns: [
          { formatter: 'responsiveCollapse', width: 40, minWidth: 30, hozAlign: 'center', resizable: false, headerSort: false, download: false },
          {
            title: 'Estimation No.',
            minWidth: 140,
            field: 'estimation_no',
            vertAlign: 'middle',
            formatter(cell) {
              const row = cell.getData()
              const link = cash(`<a href="javascript:;" class="text-primary underline">${cell.getValue()}</a>`)
              link.on('click', () => router.push({ name: 'estimation-view', params: { id: row.id } }))
              return link[0]
            }
          },
          { title: 'Date', minWidth: 120, field: 'estimation_date', hozAlign: 'center', vertAlign: 'middle' },
          { title: 'Manager/User', minWidth: 160, field: 'manager_name', vertAlign: 'middle' },
          { title: 'Total Tags', minWidth: 110, field: 'total_tags', hozAlign: 'right', vertAlign: 'middle' },
          { title: 'Total Parts', minWidth: 110, field: 'total_parts', hozAlign: 'right', vertAlign: 'middle' },
          { title: 'Total Weight', minWidth: 120, field: 'total_weight', hozAlign: 'right', vertAlign: 'middle', formatter: (cell) => formatNumber(cell.getValue(), 3) },
          { title: 'Total Amount', minWidth: 140, field: 'total_amount', hozAlign: 'right', vertAlign: 'middle', formatter: (cell) => formatNumber(cell.getValue(), 2) },
          {
            title: 'Status',
            minWidth: 110,
            field: 'status_text',
            hozAlign: 'center',
            vertAlign: 'middle',
            formatter(cell) {
              const row = cell.getData()
              const active = row.status == 1
              const expired = row.status == 2
              if (expired) {
                return cash(`<div class="flex items-center lg:justify-center text-gray-600">
                  <i data-feather="clock" class="w-4 h-4 mr-2"></i> Expired
                </div>`)[0]
              }
              const statusButton = cash(`<div class="flex items-center lg:justify-center cursor-pointer ${active ? 'text-theme-9' : 'text-theme-6'}">
                <i data-feather="check-square" class="w-4 h-4 mr-2"></i> ${active ? 'Active' : 'Inactive'}
              </div>`)
              statusButton.on('click', () => {
                const nextStatus = active ? '0' : '1'
                swal.fire({
                  title: 'Are you sure?',
                  text: active
                    ? 'Do you want to inactive the estimation status?'
                    : 'Do you want to active the estimation status?',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No'
                }).then((result) => {
                  if (!(result.isConfirmed || result.value)) return
                  axios.post(BASE_URL + `api/estimation/finalize/${row.id}`, {
                    estimation_date: row.estimation_date,
                    status: nextStatus
                  }, {
                    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                  }).then(() => {
                    return cell.getRow().update({
                      status: Number(nextStatus),
                      status_text: nextStatus === '1' ? 'Active' : 'Inactive'
                    })
                  }).then(() => {
                    feather.replace({ 'stroke-width': 1.5 })
                  })
                })
              })
              return statusButton[0]
            }
          },
          {
            title: 'Actions',
            minWidth: 80,
            field: 'actions',
            hozAlign: 'center',
            vertAlign: 'middle',
            headerSort: false,
            download: false,
            formatter(cell) {
              const row = cell.getData()
              if (row.status == 2) {
                const viewAction = cash(`<div class="flex lg:justify-center items-center">
                  <a class="flex items-center" href="javascript:;" data-action="view">
                    <i data-feather="eye" class="w-4 h-4 mr-1"></i> View
                  </a>
                </div>`)
                cash(viewAction).find('[data-action="view"]').on('click', () => router.push({ name: 'estimation-view', params: { id: row.id } }))
                return viewAction[0]
              }
              const actions = cash(`<div class="flex lg:justify-center items-center">
                <a class="flex items-center" href="javascript:;" data-action="edit">
                  <i data-feather="check-square" class="w-4 h-4 mr-1"></i> Edit
                </a>
              </div>`)
              cash(actions).find('[data-action="edit"]').on('click', () => router.push({ name: 'estimation-edit', params: { id: row.id } }))
              return actions[0]
            }
          }
        ],
        renderComplete() {
          feather.replace({ 'stroke-width': 1.5 })
        }
      })
    }

    const formatNumber = (value, precision) => Number(value || 0).toFixed(precision)
    const onFilter = () => tabulator.value.setFilter(filter.field, filter.type, filter.value)
    const onResetFilter = () => {
      filter.field = 'estimation_no'
      filter.type = 'like'
      filter.value = ''
      tabulator.value.clearFilter(true)
    }
    const onExportCsv = () => tabulator.value.download('csv', 'estimations.csv')
    const onExportXlsx = () => {
      window.XLSX = xlsx
      tabulator.value.download('xlsx', 'estimations.xlsx', { sheetName: 'Estimations' })
    }

    onMounted(() => {
      initTabulator()
      window.addEventListener('resize', () => {
        tabulator.value.redraw()
        feather.replace({ 'stroke-width': 1.5 })
      })
    })

    return {
      tableRef,
      filter,
      onFilter,
      onResetFilter,
      onExportCsv,
      onExportXlsx
    }
  }
})
</script>
